module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Double-check-e8ef867ef0a420c4be0ce10569ad6733.svg";